/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Waiting_ButtonInputs */

const en_applicants_bulk_waiting_button = /** @type {(inputs: Applicants_Bulk_Waiting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to waiting list`)
};

const de_applicants_bulk_waiting_button = /** @type {(inputs: Applicants_Bulk_Waiting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Warteliste`)
};

/**
* | output |
* | --- |
* | "Move to waiting list" |
*
* @param {Applicants_Bulk_Waiting_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_waiting_button = /** @type {((inputs?: Applicants_Bulk_Waiting_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Waiting_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_waiting_button(inputs)
	return en_applicants_bulk_waiting_button(inputs)
});